import styled from "styled-components";
import { shade } from "polished";

export const Area = styled.div<{ isShown: boolean }>`
  left: -260px;
  position: relative;
  top: 0;
  width: 300px;
  overflow-y: hidden;
  background-color: #ffffff;
  border-radius: 10px;
  display: ${({ isShown }) => (isShown ? "flex" : "none")};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  flex-direction: column;
  z-index: 100;

  h3 {
    color: ${({ theme }) => shade(0.2, theme.colors.primaryBlue.main)};
  }
  ul {
    display: flex;
    list-style: none;
    font-size: 0.8rem;
    margin: 0;
    padding: 0 0.6rem 0 0;

    color: ${({ theme }) => theme.colors.primaryBlue.text};

    li {
      white-space: break-spaces;
      border-bottom: 1px dotted ${({ theme }) => theme.colors.primaryBlue.text};
      font-size: 1rem;
      color: ${({ theme }) => shade(0.2, theme.colors.primaryBlue.main)};
      border-radius: 10px;
      text-align: left;
      margin-bottom: 0.3125rem;
    }
  }
`;

export const AreaContainer = styled.div`
  display: inline-block;
  position: absolute;
  height: auto;
  width: auto;
  margin-top: 45px;
  z-index: 20;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
`;

export const Header = styled.div`
    text-align: center;
    padding: 1rem;
`;